import requests from "./api";
import endpoints from "../constants/endpoints";

// Clears the cache by calling the backend's trigger-cache-revalidation endpoint.
// The backend will then forward the request to the Next.js site.
//
// target: { slug, group } | { slug: [..] } | { path } | { all: true }
// Resolves to true when the site confirmed the clear; never throws.
export default async function clearSiteCache(target) {
  try {
    const api = requests();
    const payload = {};

    // Map the incoming target (which uses ticket-app format) 
    // to the payload format our backend expects (path/tag)
    if (target.all) {
      payload.tag = "cms";
    } else if (target.slug) {
      const slugArray = Array.isArray(target.slug) ? target.slug : [target.slug];
      // Use the first slug as the path, but pass all as tags
      const cleanSlug = slugArray[0].replace(/^\/+|\/+$/g, "");
      payload.path = `/${cleanSlug}`;
      payload.tag = slugArray.map(s => `cms-${s.replace(/^\/+|\/+$/g, "")}`);
      if (target.group) {
        payload.tag.push(`cms-group-${target.group}`);
      }
    } else if (target.path) {
      payload.path = target.path;
      payload.tag = `cms-${target.path.replace(/^\/+|\/+$/g, "")}`;
    }

    const response = await api.post(endpoints.clear_cms_cache, payload, true);
    
    // We assume backend returns status === "Success" or status === true
    return response?.status === true || response?.status === "Success" || response?.revalidated === true;
  } catch (error) {
    console.error("clearSiteCache failed:", error);
    return false;
  }
}
